'use client';

import React from 'react';
import { sdk } from '@/sdk';

import { SWRProvider } from './swr';
import TracingProvider from './tracing';
import ShipAndLanguageProvider from './ship-and-language';
import I18nProvider from './I18n';
import StoreAndBusinessUnitsProvider from './store-and-business-units';

import { ProvidersProps } from './types';

export const Providers = ({
  locale,
  translations,
  initialData,
  page,
  children,
}: React.PropsWithChildren<ProvidersProps>) => {
  sdk.defaultConfigure(locale);
  return (
    <TracingProvider page={page}>
      <I18nProvider translations={translations}>
        <SWRProvider
          value={{
            fallback: {
              '/action/account/getAccount': { data: initialData.account },
              '/action/business-unit/getBusinessUnits': { data: initialData.businessUnits },
              '/action/business-unit/getAssociate': { data: initialData.associate },
              '/action/customObject/getCustomObject': { data: initialData.channelsVisibilitySettings },
            },
          }}
        >
          <ShipAndLanguageProvider locations={initialData.projectSettings}>
            <StoreAndBusinessUnitsProvider businessUnits={initialData.businessUnits}>
              {children}
            </StoreAndBusinessUnitsProvider>
          </ShipAndLanguageProvider>
        </SWRProvider>
      </I18nProvider>
    </TracingProvider>
  );
};
